import { noop } from "@common/helpers/function";
import { createContext, useContext } from "react";
import { DropzoneInputProps, DropzoneRootProps } from "react-dropzone";

export interface LogoUploadContextValue {
    isDragActive: boolean;
    inputProps: DropzoneInputProps;
    rootProps: DropzoneRootProps;
    isUploading: boolean;
    open(): void;
}

export const logoUploadContext = createContext<LogoUploadContextValue>({
    isDragActive: false,
    inputProps: {},
    rootProps: {},
    isUploading: false,
    open: noop,
});

export const useLogoUpload = () => {
    const context = useContext(logoUploadContext);

    if (!context) {
        throw new Error(
            "useLogoUpload must be used within a LogoUploadProvider",
        );
    }

    return context;
};
